/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CountryResponse } from '../models/country-response';
import { GetCountryResponse } from '../models/get-country-response';

/**
 * Countries
 */
@Injectable({ providedIn: 'root' })
export class CountryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllCountry()` */
  static readonly GetAllCountryPath = '/api/v1/countries';

  /**
   * Get list of countries.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllCountry()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCountry$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       *   - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetCountryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CountryService.GetAllCountryPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetCountryResponse>;
        })
      );
  }

  /**
   * Get list of countries.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllCountry$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCountry(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       *   - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetCountryResponse> {
    return this.getAllCountry$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<GetCountryResponse>): GetCountryResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `getCountryById()` */
  static readonly GetCountryByIdPath = '/api/v1/countries/{id}';

  /**
   * fetch Country details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCountryById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountryById$Response(
    params: {
      /**
       * The countries id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CountryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CountryService.GetCountryByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CountryResponse>;
        })
      );
  }

  /**
   * fetch Country details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCountryById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountryById(
    params: {
      /**
       * The countries id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<CountryResponse> {
    return this.getCountryById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CountryResponse>): CountryResponse => r.body)
    );
  }
}
